import axios from 'axios';
import store from '@/store';
import router from '@/router';
import _ from 'lodash';

const Axios = axios.create({
    baseURL:
        process.env.NODE_ENV === 'development'
            ? 'http://127.0.0.1:3000/management'
            : 'https://appelectoral.udg.mx/api/management',
});

Axios.interceptors.request.use(
    function(config) {
        // Do something before request is sent
        const token = store.getters.token;
        if (token) {
            config.headers.jwt = token;
        }
        return config;
    },
    function(error) {
        // Do something with request error
        if (!error.status) {
            // network error
        }
        return Promise.reject(error);
    }
);

Axios.interceptors.response.use(
    function(response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        const token = _.get(response, 'headers.token');
        if (token) {
            store.commit('SET_TOKEN', token);
        }
        return response;
    },
    function(error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if (_.get(error, 'response.status') === 401) {
            store.commit('SET_TOKEN', null);
            const token = store.getters.token;
            if (!token && window.location.pathname !== '/login') {
                router.push('/login');
                return Promise.reject(error);
            }
        }

        if (_.get(error, 'response.status') === 403) {
            return Promise.reject('No tienes suficientes permisos');
        }

        if (_.get(error, 'response.status') === 400) {
            return Promise.resolve(error.response);
        }

        return Promise.reject(error);
    }
);

export default Axios;
